import { z } from 'zod';
import { BaseResponseSchema, CheckContainerBarcodeQuerySchema, CheckContainerBarcodeResponseSchema, ContainerBeaconHistoryResponseSchema, ContainerHistoryRequestSchema, ContainerHistoryResponseSchema, ContainerIdParamSchema, ContainerSlotsResponseSchema, ContainerSummaryStatsSchema, CreateContainerRequestSchema, CreateContainerResponseSchema, CreateContainerWithWafersRequestSchema, CreateContainerWithWafersResponseSchema, DateWindowSchema, DeleteContainerFilesResponseSchema, FileDeleteRequestSchema, GetContainerByIdResponseSchema, GetContainersRequestSchema, GetContainersResponseSchema, GetContainerSummariesRequestSchema, GetContainerSummariesResponseSchema, SuggestContainerNameResponseSchema, UpdateContainerRequestSchema, UpdateContainerResponseSchema, } from '../../schemas.js';
import { ScannedNodeResolveApiResponseSchema, ScannedNodeResolveQuerySchema, } from '../../scanned-node.js';
/** REST contract for `insight-api/src/routes/tenant/containers.routes.ts`. */
export const containersContract = {
    list: {
        method: 'GET',
        path: '/tenant/containers',
        query: GetContainersRequestSchema,
        response: GetContainersResponseSchema,
        responseStyle: 'unwrap-data',
        queryLimitMax: 100,
        errorMessage: 'Failed to fetch containers',
    },
    summaries: {
        method: 'GET',
        path: '/tenant/containers/summaries',
        query: GetContainerSummariesRequestSchema,
        response: GetContainerSummariesResponseSchema,
        responseStyle: 'unwrap-data',
        queryLimitMax: 100,
        dedupe: true,
        errorMessage: 'Failed to fetch container summaries',
    },
    checkBarcode: {
        method: 'GET',
        path: '/tenant/containers/check-barcode',
        query: CheckContainerBarcodeQuerySchema,
        response: CheckContainerBarcodeResponseSchema,
        responseStyle: 'parse-response',
    },
    suggestName: {
        method: 'GET',
        path: '/tenant/containers/suggest-name',
        response: SuggestContainerNameResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'containerName',
        errorMessage: 'Failed to suggest container name',
    },
    resolveNode: {
        method: 'GET',
        path: '/tenant/containers/resolve-node',
        query: ScannedNodeResolveQuerySchema,
        response: ScannedNodeResolveApiResponseSchema,
        responseStyle: 'unwrap-data',
    },
    create: {
        method: 'POST',
        path: '/tenant/containers',
        body: CreateContainerRequestSchema,
        response: CreateContainerResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to create container',
    },
    createWithWafers: {
        method: 'POST',
        path: '/tenant/containers/batch-with-wafers',
        body: CreateContainerWithWafersRequestSchema,
        response: CreateContainerWithWafersResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 120000,
        errorMessage: 'Failed to create container with wafers',
    },
    getById: {
        method: 'GET',
        path: '/tenant/containers/:id',
        pathParams: ContainerIdParamSchema,
        response: GetContainerByIdResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to fetch container',
    },
    update: {
        method: 'PUT',
        path: '/tenant/containers/:id',
        pathParams: ContainerIdParamSchema,
        body: UpdateContainerRequestSchema,
        response: UpdateContainerResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update container',
    },
    delete: {
        method: 'DELETE',
        path: '/tenant/containers/:id',
        pathParams: ContainerIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete container',
    },
    getSlotMap: {
        method: 'GET',
        path: '/tenant/containers/:id/slots',
        pathParams: ContainerIdParamSchema,
        response: ContainerSlotsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to fetch container slot map',
    },
    deleteFiles: {
        method: 'DELETE',
        path: '/tenant/containers/:id/files',
        pathParams: ContainerIdParamSchema,
        body: FileDeleteRequestSchema,
        response: DeleteContainerFilesResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to delete container files',
    },
    getHistory: {
        method: 'GET',
        path: '/tenant/containers/:id/history',
        pathParams: ContainerIdParamSchema,
        query: ContainerHistoryRequestSchema,
        response: ContainerHistoryResponseSchema,
        responseStyle: 'unwrap-data',
        queryLimitMax: 100,
        errorMessage: 'Failed to fetch container history',
    },
    getHistoryStats: {
        method: 'GET',
        path: '/tenant/containers/:id/history/stats',
        pathParams: ContainerIdParamSchema,
        response: ContainerSummaryStatsSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to fetch container history stats',
    },
    getBeaconHistory: {
        method: 'GET',
        path: '/tenant/containers/:id/beacon-history',
        pathParams: ContainerIdParamSchema,
        response: ContainerBeaconHistoryResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to fetch container beacon history',
    },
    exportHistory: {
        method: 'GET',
        path: '/tenant/containers/:id/export/history',
        pathParams: ContainerIdParamSchema,
        query: DateWindowSchema,
        response: z.unknown(),
        responseStyle: 'blob',
        timeoutMs: 60000,
        errorMessage: 'Failed to export container history',
    },
};
//# sourceMappingURL=containers.contract.js.map